<template>
  <div class="mb-8">
    <h3 class="mb-4 text-lg font-semibold text-gray-900 dark:text-gray-100">
      Recent Orders
    </h3>
    <DataTable
      :items="orders"
      :columns="columns"
      :pagination="pagination"
      @routeChange="viewOrder"
      @pageChange="handlePageChange">
      <template #business="{ item }">
        <div class="text-sm font-medium text-gray-900 dark:text-gray-200">
          {{ item?.business?.name || 'N/A' }}
        </div>
        <div class="text-sm text-gray-500 dark:text-gray-400">
          {{ item?.business?.address || 'N/A' }}
        </div>
      </template>
      <template #customer="{ item }">
        <div class="text-sm font-medium text-gray-900 dark:text-gray-200">
          {{ item?.customer?.name || 'N/A' }}
        </div>
        <div class="text-sm text-gray-500 dark:text-gray-400">
          {{ item?.customer?.phone || 'N/A' }}
        </div>
      </template>

      <template #total="{ item }">
        {{ nairaSymbol }}{{ Number(item?.total_amount || 0).toFixed() }}
      </template>

      <template #order_status="{ item }">
        <span
          class="inline-flex px-2 text-xs font-semibold leading-5 rounded-full"
          :class="statusColors[item?.status || 'pending']">
          {{ orderStatusLabels[item?.status || 'pending'] }}
        </span>
      </template>

      <template #payment_status="{ item }">
        <span
          class="inline-flex px-2 text-xs font-semibold leading-5 rounded-full"
          :class="statusColors[item?.payment_status || 'pending']">
          {{ paymentStatusLabels[item?.payment_status || 'pending'] }}
        </span>
      </template>

      <template #date="{ item }">
        {{ item?.created_at ? new Date(item.created_at).toLocaleDateString() : 'N/A' }}
      </template>
    </DataTable>
  </div>
</template>

<script setup>
import DataTable from '@/components/general/DataTable.vue';
import { useRouter } from 'vue-router';
import { ROUTES } from '@/router/routeNames';
// import { getOrderStatus, columns } from '@/utils/orders';
import { statusColors, columns, paymentStatusLabels, orderStatusLabels } from '@/constants'
import { nairaSymbol } from '@/constants'

const router = useRouter();
const emit = defineEmits(['pageChange']);
const props = defineProps({
    orders: {
        type: Array,
        required: true,
        default: () => []
    },
    pagination: {
        type: Object,
        required: false,
        default: () => ({
            current_page: 1,
            last_page: 1,
            from: 1,
            to: 10,
            total: 10
        })
    }
});



function formatCurrency(amount) {
    return new Intl.NumberFormat('en-NG', { style: 'currency', currency: 'NGN' }).format(amount);
}

function getStatusClass(status) {
    const classes = {
        pending: 'bg-yellow-100 text-yellow-800 dark:bg-yellow-900 dark:text-yellow-200',
        processing: 'bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-200',
        completed: 'bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-200',
        cancelled: 'bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-200'
    };
    return classes[status] || 'bg-gray-100 text-gray-800 dark:bg-gray-900 dark:text-gray-200';
}

function handlePageChange(page) {
    emit('pageChange', page);
}

function viewOrder(orderId) {
    router.push({ name: ROUTES.DASHBOARD_ORDER, params: { id: orderId } });
}
</script>
